import apiClient from './apiClient';

export async function getCurrentUser() {
  const response = await apiClient.get('/api/auth/me');
  return response.data;
}

export async function logout() {
  const response = await apiClient.post('/api/auth/logout');
  return response.data;
}

export const authService = {
  getCurrentUser,
  logout,
};

export default authService;
